<template>
  <section class="report">
    <div class="outer">
      <div class="intro">
        <headline kicker="Finanzen und Nachhaltigkeit" headline="Außergewöhnlich erfolgreich" class="white" />
        <p>Unsere an starken Werten orientierte Unternehmensstrategie hat sich 2020 unter außergewöhnlichen Rahmenbedingungen bewährt. Entdecken Sie unsere wichtigsten Finanzkennzahlen sowie die Zusammenfassung unserer nichtfinanziellen Aktivitäten des vergangenen Geschäftsjahres. </p>
        <button-link router-link="/finanzbericht/details/" label="Zu den Finanzkennzahlen" color="white" />
        <button-link router-link="/nachhaltigkeitsbericht/" label="Nachhaltigkeit bei enercity" color="white" />
      </div>
      <div class="image-box">
        <img src="../assets/images/report/report-teaser.jpg" alt="">
      </div>
      <report-tile/>
      <div class="mobile-buttons">
        <button-link router-link="/finanzbericht/details/" label="Zu den Finanzkennzahlen" color="white" />
        <button-link router-link="/nachhaltigkeitsbericht/" label="Nachhaltigkeit bei enercity" color="white" />
      </div>
    </div>
    <div class="footer">
      <site-footer/>
    </div>
  </section>
</template>

<script>
  import Headline from "../elements/Headline";
  import ButtonLink from "../elements/ButtonLink";
  import SiteFooter from "@/components/SiteFooter";
  import ReportTile from "@/elements/ReportTile";
  export default {
    name: "SectionReport",
    components: {ReportTile, SiteFooter, ButtonLink, Headline}
  }
</script>

<style scoped>
  .report {
    position: relative;
    display: flex;
    align-items: flex-end;
    background-color: #102D61;
    color: white;
    padding: 0 0 0 calc(120px + 4vw);
  }
  .report:before {
    content: "";
    position: absolute;
    left: -5px;
    top: -5px;
    width: 20vh;
    height: 110vh;
    background-color: #102D61;
    transform-origin: left top;
    transform: rotate(6deg);
  }
  .footer {
    position: relative;
    max-width: calc(300px + 11vh);
    flex: 1 1 calc(300px + 11vh);
    height: 100%;
    margin-left: auto;
  }
  .outer {
    position: relative;
    height: calc(90vh - 80px);
    display: flex;
    align-items: center;
  }
  .intro {
    position: relative;
    min-width: 360px;
    align-self: center;
  }
  .headlines {
    margin-bottom: 30px;
  }
  p {
    margin-top: 0;
  }
  h3 {
    margin-bottom: 6px;
  }
  .image-box {
    position: relative;
    display: block;
    margin-right: -6vh;
    align-self: flex-end;
  }
  .image-box img {
    height: calc(99vh - 140px);
    margin: 0 12%;
    display: block;
  }
  .mobile-buttons {
    display: none;
  }
  @media(max-width: 999px) {
    .report {
      display: block;
      height: auto;
      padding: calc(20px + 2%) 14px 0;
    }
    .report:before {
      left: 0;
      top: 0;
      width: 120vw;
      height: 15vw;
      transform: rotate(-8deg);
    }
    .outer {
      display: block;
      padding: 40px 20px;
      height: auto;
    }
    .footer {
      max-width: none;
      margin: 0 -14px;
    }
    .intro {
      max-width: 50%;
      padding-right: 25px;
    }
    .image-box {
      position: absolute;
      top: 14%;
      right: -30px;
      width: 50%;
      margin: 0;
    }
    .image-box img {
      max-width: 100%;
      margin: 0;
      height: auto;
    }
  }
  @media(max-width: 567px) {
    .report {
      padding: calc(30px + 2%) 0 0;
    }
    .image-box {
      display: none;
    }
    .mobile-buttons {
      display: block;
      padding: calc(6vw + 30px) 0;
    }
    .intro .button {
      display: none;
    }
    .footer {
      margin: 0;
    }
  }
</style>